
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useTrackingMode, useTrackingQuery } from '@aftersale-next/tracking';
import { When } from '@aftersale-next/ui';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useConfirmation, useOrder, useEcommerceName, useEcommerceEnabled, useEcommerceConfirmationType } from '@aftersale-next/atoms';
import { useTranslation } from '../lib/hooks/use-translation';
import BasicPageLayout from '../lib/components/basic-page-layout';
import { Page } from '../lib/components/page';
import { FormLogin } from '../lib/components/form-login';
import { useOrderAutoSetupEffect } from '../lib/hooks/use-order-auto-setup-effect';
import { useConfirmationAutoSetupEffect } from '../lib/hooks/use-confirmation-auto-setup-effect';
import { Heading, ErrorMessage } from '@aftersale-next/ui';
import { useEmbedAutoSetupEffect } from '../lib/hooks/use-embed-auto-setup-effect';
import { shouldRedirectToChannels } from '../lib/utils/should-redirect-to-channels';
import { useGoToTracking } from '../lib/hooks/redirects/use-go-to-tracking';
import { useGoToChannel } from '../lib/hooks/redirects/use-go-to-channel';
import { usePackageIndexAutoSetupEffect } from '../lib/hooks/use-package-index-auto-setup-effect';
import { useRouter } from 'next/router';
export default function LoginPage() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useOrder = useOrder(),
      _useOrder2 = _slicedToArray(_useOrder, 2),
      order = _useOrder2[0],
      setOrder = _useOrder2[1];

  var _useConfirmation = useConfirmation(),
      _useConfirmation2 = _slicedToArray(_useConfirmation, 2),
      confirmation = _useConfirmation2[0],
      setConfirmation = _useConfirmation2[1];

  var package_index = useRouter().query.package_index;

  var _useEcommerceName = useEcommerceName(),
      _useEcommerceName2 = _slicedToArray(_useEcommerceName, 1),
      ecommerceName = _useEcommerceName2[0];

  var _useEcommerceEnabled = useEcommerceEnabled(),
      _useEcommerceEnabled2 = _slicedToArray(_useEcommerceEnabled, 1),
      isEcommerceEnabled = _useEcommerceEnabled2[0];

  var _useEcommerceConfirma = useEcommerceConfirmationType(),
      _useEcommerceConfirma2 = _slicedToArray(_useEcommerceConfirma, 1),
      ecommerceConfirmationType = _useEcommerceConfirma2[0];

  var _useTrackingMode = useTrackingMode(),
      _useTrackingMode2 = _slicedToArray(_useTrackingMode, 2),
      setTrackingMode = _useTrackingMode2[1];

  var pushToTracking = useGoToTracking();
  var pushToChannel = useGoToChannel();
  var orderQuery = useTrackingQuery({
    onSuccess: function onSuccess(data) {
      var _data$tracking, _data$tracking$packag;

      var isMultiplePackages = (data === null || data === void 0 ? void 0 : (_data$tracking = data.tracking) === null || _data$tracking === void 0 ? void 0 : (_data$tracking$packag = _data$tracking.packages) === null || _data$tracking$packag === void 0 ? void 0 : _data$tracking$packag.length) > 1;

      if (shouldRedirectToChannels(data)) {
        pushToChannel(order, confirmation);
      } else {
        var _data$tracking$custom, _data$tracking2;

        pushToTracking({
          order: order,
          confirmation: confirmation,
          packageIndex: undefined,
          embed: undefined,
          document: (_data$tracking$custom = data === null || data === void 0 ? void 0 : (_data$tracking2 = data.tracking) === null || _data$tracking2 === void 0 ? void 0 : _data$tracking2.customer.document) !== null && _data$tracking$custom !== void 0 ? _data$tracking$custom : undefined
        });
        isMultiplePackages && !package_index ? setTrackingMode('packages-list') : setTrackingMode('package-details');
      }
    },
    disableRefetchInterval: true
  });

  var handleSetLogin = function handleSetLogin(_ref) {
    var order = _ref.order,
        confirmation = _ref.confirmation;
    setOrder(order);
    setConfirmation(confirmation);
    orderQuery.refetch();
  };

  useOrderAutoSetupEffect();
  usePackageIndexAutoSetupEffect();
  useConfirmationAutoSetupEffect();
  useEmbedAutoSetupEffect();
  return /*#__PURE__*/_jsx(Page, {
    testid: "login-page",
    needEnableCheck: true,
    children: /*#__PURE__*/_jsx(When, {
      value: !!isEcommerceEnabled,
      children: function children() {
        return /*#__PURE__*/_jsxs(BasicPageLayout, {
          children: [/*#__PURE__*/_jsxs(Flex, {
            direction: "column",
            justify: "center",
            align: "center",
            mb: "6",
            mt: "4",
            px: "4",
            children: [/*#__PURE__*/_jsx(Heading, {
              content: t('track_your_order')
            }), /*#__PURE__*/_jsx(Text, {
              color: "text.primary",
              align: "center",
              fontSize: "md",
              w: {
                md: '80'
              },
              children: t('descriptions.login_page_description')
            })]
          }), /*#__PURE__*/_jsx(Box, {
            px: "4",
            w: "100%",
            children: /*#__PURE__*/_jsx(FormLogin, {
              onSubmit: handleSetLogin,
              confirmationType: ecommerceConfirmationType,
              loading: orderQuery.isLoading,
              order: order,
              confirmation: confirmation
            })
          }), /*#__PURE__*/_jsx(When, {
            value: orderQuery.isError,
            children: /*#__PURE__*/_jsx(ErrorMessage, {
              title: t('errors.order_not_found_title'),
              message: t('errors.order_not_found_message', {
                ecommerce_name: ecommerceName
              })
            })
          })]
        });
      }
    })
  });
}

// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/login',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  